import { initializeApp } from "firebase/app";
import { 
  getFirestore, 
  initializeFirestore, 
  persistentLocalCache, 
  persistentMultipleTabManager 
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDBaAdbPdFNoYl9gzNk5vFx_PFM0kydhJ8",
  authDomain: "glg-panah-cms.firebaseapp.com",
  projectId: "glg-panah-cms",
  storageBucket: "glg-panah-cms.firebasestorage.app",
  messagingSenderId: "175740225418",
  appId: "1:175740225418:web:938d886e71d209ecdc2a73",
  measurementId: "G-22T5H6MXTX"
};

const app = initializeApp(firebaseConfig);

// Initialize Firestore with settings to avoid ad-blocker detection and CORS issues
// Using experimentalForceLongPolling: true forces the SDK to use long-lived HTTP requests
// instead of WebSockets/Streaming which are often blocked.
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;
